// extracted by mini-css-extract-plugin
module.exports = {"navigation":"AuthNav_navigation__2wXT9","link":"AuthNav_link__3gi8q","activeLink":"AuthNav_activeLink__1JsJ0"};